import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import EventNews from "../../components/eventNews/EventNews";
import BlogCard from "../../components/blogCard/BlogCard";
import Button from "../../components/button/Button";
import BlogImage from "../../assets/blogImage.png";
import "./blogdetail.css";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";
import { NavLink } from "react-router-dom";
import axios from "axios";
import ErrorPage from "../404_page/ErrorPage";

const BlogDetail = () => {
  const { url } = useParams();

  const [blogs, setBlogs] = useState([]);
  const [mainTitle, setMainTitle] = useState("");
  const [post, setPost] = useState("");
  const [loading, setLoading] = useState(true);
  const [readTime, setReadTime] = useState("");
  const [page, setPage] = useState(parseInt(1));
  const [tags, setTags] = useState("");
  const [loadData, setLoadData] = useState(true);

  const [currentPage] = useState(1);
  const itemsPerPage = 6;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://blog.giftcard8.com/wp-json/wp/v2/posts?slug=${url}`
        );
        if (response) {
          setMainTitle(response.data[0].title.rendered);
          setReadTime(`
            ${response.data[0].yoast_head_json.twitter_misc["Est. reading time"]} read
          `);
          setTags(response.data[0].yoast_head);

          const content = response.data[0].content.rendered;
          const styledContent = ` 
            <html>
              <head>
                <style>
                  p {
                    line-height: 1.8;
                    color: #555;
                    margin: 0 0 16px;
                  }
                  li {
                    color: #555;
                  }
                  figure.wp-block-image img {
                    width: 100%; /* Makes the image responsive */
                    max-width: 1024px; /* Ensures it doesn't exceed 982px */
                    height: auto; /* Maintains aspect ratio */
                    max-height: 394px; /* Ensures it doesn't exceed 377px */
                    display: block; /* Removes extra spacing below images */
                    margin: 0 auto; /* Centers the image */
                  }
                  
                </style>
              </head>
              <body>
                ${content}
              </body>
            </html>`;

          setPost(styledContent); // Inject styled content
        } else {
          // setPost("<p>No content available.</p>");
          setLoadData(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadData(false);
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchData();
  }, [url]); // Add categoryId and blogId as dependencies

  useEffect(() => {
    const fetchNextData = async () => {
      try {
        const response = await axios.get(
          `https://blog.giftcard8.com/wp-json/wp/v2/posts?page=${page}&per_page=6`
        );
        if (response.data.length > 0) {
          setBlogs(response.data);
        } else {
          setPost("<p>No content available.</p>");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setPost("<p>Error loading content. Please try again later.</p>");
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchNextData();
  }, [page]);

  useEffect(() => {
    if (tags) {
      // Remove any previous injected meta tags
      document.querySelectorAll(".dynamic-meta").forEach((el) => el.remove());

      const head = document.head;
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = tags;

      // Append each meta tag to the <head>
      Array.from(tempDiv.children).forEach((child) => {
        child.classList.add("dynamic-meta"); // Mark them for easy removal later
        // Replace 'blog.giftcard8.com' with 'giftcard8.com' in URLs

        // Replace 'blog.giftcard8.com' with 'giftcard8.com' in URLs, but skip image URLs
        if (child.tagName === "META" || child.tagName === "LINK") {
          if (child.hasAttribute("content")) {
            // Skip replacing image URLs
            const contentValue = child.getAttribute("content");
            if (!contentValue.includes("wp-content/uploads")) { // Check if it's not an image URL
              child.setAttribute("content", contentValue.replace("blog.giftcard8.com", "giftcard8.com"));
            }
          }

          if (child.hasAttribute("href")) {
            // Skip replacing image URLs
            const hrefValue = child.getAttribute("href");
            if (!hrefValue.includes("wp-content/uploads")) { // Check if it's not an image URL
              child.setAttribute("href", hrefValue.replace("blog.giftcard8.com", "giftcard8.com"));
            }
          }
        }

        head.appendChild(child);
      });
    }
  }, [tags]);

  function removeBaseUrl(url) {
    const baseUrl = "https://blog.giftcard8.com/blog/";
    return url.startsWith(baseUrl) ? url.slice(baseUrl.length) : url;
  }
  const handleNext = () => {
    // if (currentPage < Math.ceil(blogs.length / itemsPerPage)) {
    //   setCurrentPage(currentPage + 1);
    // }
    setPage((prevPage) => prevPage + 1);
  };

  const handleBack = () => {
    // if (currentPage > 1) {
    //   setCurrentPage(currentPage - 1);
    // }
    setPage((prevPage) => prevPage - 1);
  };

  const indexOfLastBlog = currentPage * itemsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - itemsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  return (
    <>
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      {loadData ? (
        <>
          <div
            className="container d-flex flex-column justify-content-center align-items-center blgSection1"
            style={{ marginTop: "120px" }}
          >
            <div
              className="w-100 mb-3 backButton"
              style={{ visibility: "hidden" }}
            >
              <NavLink to="/blog" style={{ textDecoration: "none" }}>
                <span
                  className="fw-bold rounded-4 fs-6 badge bg-light text-dark d-flex align-items-center"
                  style={{ fontSize: "12px", width: "100px" }}
                >
                  <i
                    className="bi bi-arrow-left mx-2"
                    style={{ fontSize: "12px" }}
                  ></i>
                  Back
                </span>
              </NavLink>
            </div>
            <span
              className="fw-bold rounded-4 fs-6 badge bg-light text-dark d-flex align-items-center mb-3"
              style={{ fontSize: "12px" }}
            >
              <i className="bi bi-dot" style={{ fontSize: "20px" }}></i>
              {readTime}
            </span>

            {/* Skeleton for Title */}
            {loading ? (
              <div className="skeleton-title"></div>
            ) : (
              <h3 className="fw-bold mt-4 text-center">{mainTitle}</h3>
            )}

            <style>
              {`
          @media (max-width: 767px) {
            .responsive-img {
              width: 100% !important;
            }
          }
          .skeleton {
            background-color: #e0e0e0;
            border-radius: 4px;
          }
          .skeleton-title {
            width: 50%;
            height: 30px;
            margin: 0 auto;
          }
          .skeleton-image {
            width: 80%;
            height: 400px;
            margin: 20px auto;
          }
          .skeleton-content {
            width: 80%;
            height: 200px;
            margin: 20px auto;
            background-color: #e0e0e0;
            border-radius: 4px;
          }
        `}
            </style>

            {/* Skeleton for Image */}
            {/* {loading ? (
          <div className="skeleton skeleton-image"></div>
        ) : (
          <img
            src={mainImgUrl}
            alt="blog image"
            className="rounded-5 my-4 img-fluid hover-effect blogImg"
            style={{ width: "80%", height: "400px", objectFit: "cover" }}
          />
        )} */}

            {/* Skeleton for Content */}
            {loading ? (
              <div className="skeleton skeleton-content"></div>
            ) : (
              <div
                style={{ margin: "0 10%", fontSize: "24px" }}
                className="blogcontent"
                dangerouslySetInnerHTML={{ __html: post }}
              ></div>
            )}
          </div>

          <div
            className="container my-5 BlogsCardsSection"
            style={{ width: "86%" }}
          >
            <h1 className="text-center my-5 fw-bold">Check out More Blogs</h1>
            <div className="row row-cols-1 row-cols-md-3 g-4 blogCards">
              {currentBlogs.map((blog, i) => (
                <div className="col-6 col-lg-4 col-md-6 col-sm-6" key={i}>
                  <BlogCard
                    title={blog.title.rendered}
                    img={blog.yoast_head_json?.og_image?.[0]?.url || BlogImage}
                    excert={blog.excerpt.rendered}
                    publishTime={blog.yoast_head_json.article_published_time}
                    url={removeBaseUrl(blog.link)}
                  />
                </div>
              ))}
            </div>
            <div className="container">
              <div className="row my-4 d-flex align-items-center justify-content-between">
                <div className="w-25 col-auto blogBtnBack d-flex justify-content-start align-items-start">
                  <Button
                    className="w-75 border hover-effect"
                    style={{
                      background: "transparent",
                      color: "#000",
                    }}
                    onClick={handleBack}
                    disabled={page <= 1}
                  >
                    ← Back
                  </Button>
                </div>
                <div className="w-25 col-auto blogBtnNext d-flex justify-content-end align-items-end">
                  <Button
                    className="w-75 border hover-effect"
                    style={{
                      background: "transparent",
                      color: "#000",
                    }}
                    onClick={handleNext}
                  >
                    Next →
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="container my-5 blgSection" style={{ width: "86%" }}>
            <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
            <EventNews />
          </div>
        </>
      ) : (
        <ErrorPage />
      )}
    </>
  );
};

export default BlogDetail;
